import * as React from "react";
import { observer } from "mobx-react";
import { withSnackbar } from "notistack";
import { toJS } from "mobx";

import {
  Paper,
  Typography,
  withStyles,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Step,
  StepLabel,
  Stepper,
  DialogContentText,
  IconButton,
} from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import i18n from "i18n";
import classNames from "classnames";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import { WBSStore } from "modules/WBS/WBSStore";
import ImportFile from "./ImportFile";
import BudgetColumn from "./BudgetColumn";
import CustomBudget from "./CustomBudget";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import {
  LoadingLayer,
  ProcessingLayer,
  FinishedLayer,
  ErrorLayer,
} from "modules/costPlan/components/layouts/LayersImportation";
import { Close } from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import { WBSService } from "modules/WBS/WBSService";
import { WBS } from "modules/WBS/models/WBS";
import CostPlanItem from "modules/costPlan/components/layouts/CostPlanItem";
import { now } from "utils/FirebaseUtils";
import { LoginStore } from "modules/login/LoginStore";
import { gtag } from "ga-gtag";
import { formatMonetary } from "utils/MathUtils";
import { ProjectStore } from "modules/project/ProjectStore";
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiStepIcon: {
      root: {
        "&$active": {
          color: "#9AAF00",
        },
        "&$completed": {
          color: "#9AAF00",
        },
        color: "#9E9E9E",
      },
    },
  },
});

const themeChangeCostPlan = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiDialog: {
      paperWidthSm: {
        width: "640px",
        height: "548px",
      },
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: "16px",
        marginBottom: "8px",
        width: "100%",
      },
    },
    MuiInputLabel: {
      root: {
        "&$focused": {
          color: "#ABC200",
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#ABC200",
        },
      },
    },
  },
});

const styles = (theme) => ({
  container: {
    backgroundColor: "#2a292f",
    height: "calc(100vh - 33px)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column" as any,
    minWidth: "250px",
  },
  paper: {
    height: 0,
  },
  topBar: {
    backgroundColor: "#3A393E",
    height: "30px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
    color: "#dedede",
  },
  topBarWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    paddingBottom: "10px",
    alignItems: "center",
  },
  uploadText: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#dedede",
    padding: "5px",
    letterSpacing: "0.5px",
    marginTop: "4px",
  },
  topBarText: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    color: "#ABC200",
    letterSpacing: "1px",
    paddingLeft: "6px",
    textTransform: "uppercase" as any,
  },
  eapBoxWrapper: {
    width: "100%",
  },
  eapInfoWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  icon: {
    color: "#A8A8A8",
    size: "11px",
    padding: "3px",
    alignItems: "middle",
  },
  button: {
    letterSpacing: "0.5px",
    fontSize: "11px",
    color: "#dedede",
    background: "#272727",
    padding: "5px 3px",
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  simpleMenu: {
    padding: 0,
  },
  simpleMenuItem: {
    padding: "5px 10px",
    color: "rgb(195, 195, 195) !important",
  },
  simpleMenuText: {
    color: "rgb(195, 195, 195) !important",
    cursor: "pointer",
  },
  eapWrapper: {
    padding: "15px 15px",
    background: "#363637",
    borderBottom: "1px solid #302F31",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  eapName: {
    color: "rgba(255, 255, 255, 87)",
    fontSize: "11px",
  },
  eapProgress: {
    color: "#FFFFFF",
    opacity: "0.3" as any,
    fontStyle: "italic",
    fontSize: "10px",
  },
  progress: {
    margin: 0,
    color: "#ABC200",
    width: "30px !important",
    height: "30px !important",
  },
  modalImportSheetContent: {
    backgroundColor: "#EEEEEE",
  },
  modalImportSheetTitle: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    padding: "24px",
    "& h6": {
      lineHeight: "1",
    },
  },
  modalImportActions: {
    backgroundColor: "#EEEEEE",
    flex: "0 0 auto",
    display: "flex",
    padding: "0px 20px 20px",
    alignItems: "center",
    paddingTop: "0.75rem",
    justifyContent: "flex-end",
    margin: "0px 0px",
  },
  stepLabel: {
    fontSize: "0.7rem",
    marginTop: "0.25rem !important",
  },
  teste: {
    minWidth: "600px!important",
    maxHeight: "473px",
    minHeight: "473px",
    borderRadius: "4px!important",
  },
  bolinha: {
    "& span": {
      cursor: "pointer",
    },
  },
  modalWbsTitle: {
    background: "#f2f2f2",
    margin: 0,
    padding: "20px",
    fontSize: "20px",
    borderBottom: "1px solid black",
  },
  modalWbsContent: {
    background: "#EEEEEE",
  },
  modalWbsActions: {
    background: "#EEEEEE",
    margin: "0px",
    padding: "1%",
  },
  formContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButton: {
    color: "#646464",
    "&:hover": {
      backgroundColor: "#e3e3e3",
    },
  },
  createNewCostPlanButton: {
    color: "#ABC200",
    "&:hover": {
      backgroundColor: "#e3e3e3",
    },
  },
  iconWrap: {
    padding: "0px",
  },
  iconUploadText: {
    border: "1px solid #1D1D1D",
    background: "#272727",
    padding: "0",
    textTransform: "uppercase" as any,
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "520px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  closeIcon: {
    right: "20px",
    top: "14px",
  },
  table: {
    height: "90vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tableCell: {
    verticalAlign: "middle",
    textAlign: "center" as any,
  },
  stageTitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "#f2f2f2",
  },
  stageSubtitle: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 300,
    color: "#a6a6a6",
  },
  confirmButton: {
    padding: "0 !important",
  },
});
function getSteps() {
  return ["Escolher arquivo", "Configuração dos campos", "Personalização"];
}
function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return <ImportFile />;
    case 1:
      return <BudgetColumn />;
    case 2:
      return <CustomBudget />;
    default:
      return "";
  }
}

type IProps = {
  classes: any;
  snack: any;
};

@observer
class CostPlanGrid extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  state = {
    anchorEl: null,
    actualFile: "",
    developmentSelected: "",
    ready: false,
    open: false,
    activeStep: 0,
    buttonNewSheet: true,
    importLoading: -1,
    expanded: null,
    openBlankWbs: false,
    nameWbs: "",
    descriptionWbs: "",
    wbsData: [],
    status: false,
    fillInputNameWbs: false,
    fillDescriptionWbs: false,
    loading: false,
    importBtndisable: false,
    nameWbsAlreadyExists: false,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    this.setState({ activeStep: 0, importLoading: -1 });
    CostPlanStore.setImportLoading(-1);
  };
  handleClose = () => {
    if (!this.state.open && !CostPlanStore.getOpenGridDialog()) {
      this.setState({ anchorEl: null });
    }
  };

  componentDidMount = async () => {
    WBSStore.refreshListWbs();
    await WBSStore.getWbsById(DevelopmentStore.developmentId);
    if (WBSStore.listWbs.length > 0) {
      this.setState({
        status: true,
      });
    }
  };

  resetVariables = () => {
    CostPlanStore.fileUpload = null;
    CostPlanStore.fileUploadName = null;
    CostPlanStore.fillStructCodeColumn = false;
    CostPlanStore.fillAlternativeCodeColumn = false;
    CostPlanStore.fillResourceCodeColumn = false;
    CostPlanStore.fillResourceQuantityColumn = false;
    CostPlanStore.fillResourceCostColumn = false;
    CostPlanStore.fillDescriptionColumn = false;
    CostPlanStore.fillCoefficientColumn = false;
    CostPlanStore.fillServiceQuantityColumn = false;
    CostPlanStore.fillServiceCostColumn = false;
    CostPlanStore.fillUnitColumn = false;
    CostPlanStore.fillAlternativeColumn = false;
    CostPlanStore.fillUnitCostColumn = false;
    CostPlanStore.fillTotalColumn = false;
    CostPlanStore.fileName = "";
    CostPlanStore.fileUpload = null;
    CostPlanStore.customColumnFields = false;
    CostPlanStore.budgetColumnFileds = false;
  };
  handleClickOpen = () => {
    this.resetVariables();
    this.setState({ open: true });
    ProjectStore.enableLoadingOnContent(true);
    CostPlanStore.setOpenGridDialog(true);
  };
  handleClickOpenBlankWbs = () => {
    this.setState({ openBlankWbs: true });
    CostPlanStore.setOpenBlankWbs(true);
  };
  handleClickCloseBlankWbs = () => {
    this.setState({
      openBlankWbs: false,
      nameWbs: "",
      descriptionWbs: "",
      fillInputNameWbs: false,
      fillDescriptionWbs: false,
      open: false,
    });
    CostPlanStore.setOpenGridDialog(false);
    CostPlanStore.setOpenBlankWbs(false);
  };
  handleClickClose = () => {
    this.setState({
      open: false,
      anchorEl: null,
      importLoading: -1,
      openBlankWbs: false,
      nameWbs: "",
      descriptionWbs: "",
      fillInputNameWbs: false,
      fillDescriptionWbs: false,
      nameWbsAlreadyExists: false,
    });
    ProjectStore.enableLoadingOnContent(false);
    CostPlanStore.setImportLoading(-1);
    CostPlanStore.setOpenGridDialog(false);
    CostPlanStore.setOpenBlankWbs(false);
    CostPlanStore.arrayObjBudgets = [];
    CostPlanStore.arrayObjCustomBudget = [];
    this.resetVariables();
    setTimeout("", 2000);
    this.handleReset();
    CostPlanStore.handleCancel();
  };
  handleClickReset = () => {
    this.setState({ activeStep: 0, importLoading: -1 });
    CostPlanStore.setImportLoading(-1);
    CostPlanStore.importCostPlanFileProgess = "0";
    CostPlanStore.importCostPlanFileStatus = "pending";
    CostPlanStore.importCostPlanFileErrorMessage = "";
    this.resetVariables();
    setTimeout("", 2000);
    this.handleReset();
  };
  setFile(file) {
    this.setState({
      actualFile: file,
    });
  }
  handleNext = () => {
    this.setState((state) => ({
      activeStep: this.state.activeStep + 1,
    }));
  };
  handleBack = () => {
    this.setState((state) => ({
      activeStep: this.state.activeStep - 1,
    }));
  };
  handleBackToStep = (e) => {
    if (e < this.state.activeStep) {
      this.setState((state) => ({
        activeStep: e,
      }));
    }
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  handleInputNameWbs = (e) => {
    if (e.target.value == "") {
      this.setState({ fillInputNameWbs: false });
    } else {
      this.setState({ fillInputNameWbs: true });
    }
    this.setState({ nameWbs: e.target.value });
  };

  handleInputDescriptionWbs = (e) => {
    if (e.target.value == "") {
      this.setState({ fillDescriptionWbs: false });
    } else {
      this.setState({ fillDescriptionWbs: true });
    }
    this.setState({ descriptionWbs: e.target.value });
  };

  refreshComponent = async () => {
    WBSStore.refreshListWbs();
    await WBSStore.getWbsById(DevelopmentStore.developmentId);
  };

  createBlankWbs = async () => {
    this.setState({ loading: true });

    const checkNameWbsAlreadyExists =
      await WBSService.checkNameWbsAlreadyExists(this.state.nameWbs);

    if (!checkNameWbsAlreadyExists) {
      let developmentId = DevelopmentStore.developmentId;
      let developmentName = DevelopmentStore.developmentName;

      await WBSService.createWBS(
        new WBS(
          developmentName,
          0,
          40,
          developmentId,
          2,
          "trunc",
          { percentual: 0, show: false },
          0,
          this.state.nameWbs,
          this.state.descriptionWbs,
          now(),
          false,
          "",
          {}
        )
      );
      gtag("event", "criacao_plano_custo", {
        criacao_plano_custo: 0,
      });

      this.setState({ nameWbs: "", descriptionWbs: "" });
      this.setState({
        fillInputNameWbs: false,
        fillDescriptionWbs: false,
      });
      this.refreshComponent();
      this.handleClickClose();
      this.setState({ loading: false });
    } else {
      this.setState({ nameWbsAlreadyExists: true });
      this.setState({ loading: false });
    }
  };
  handleChange = (panel) => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  importSheet = async () => {
    this.setState({ importBtndisable: true });
    let destination = "rubk.orcamento";
    let file = CostPlanStore.fileUpload;
    let fields = CostPlanStore.budgetColumnFileds;
    fields = toJS(fields);
    let fieldArr = Object.values(fields);
    let id = DevelopmentStore.developmentId;
    let dataFile: any = undefined;
    let customProperties: any = [];

    if (
      CostPlanStore.fieldsCustomBudgetKey !== undefined &&
      CostPlanStore.fieldsCustomBudgetValue !== undefined
    ) {
      let idsToDelete: number[] = [];
      for (let i = 0; i < CostPlanStore.arrayObjCustomBudget.length; i++) {
        const element = CostPlanStore.arrayObjCustomBudget[i];
        if (element.label == undefined) {
          idsToDelete.push(i);
        }
      }

      for (let i = idsToDelete.length - 1; i >= 0; i--) {
        const element = idsToDelete[i];
        CostPlanStore.arrayObjCustomBudget.splice(element, 1);
      }

      customProperties = CostPlanStore.arrayObjCustomBudget.filter(
        (prop) => prop && prop.column > -1 && prop.label
      );

      if (customProperties.length != -1) {
        dataFile = {
          destination,
          id,
          fields: [...fieldArr, ...customProperties],
        };
      } else {
        dataFile = {
          destination,
          id,
          fields: fieldArr,
        };
      }
    } else {
      dataFile = { destination, id, fields: fieldArr };
    }
    let Properties = {
      properties: [...CostPlanStore.arrayObjBudgets],
      customProperties: [...customProperties],
    };

    await CostPlanStore.setFileImportConfig(
      Properties,
      LoginStore.userAuth!.uid
    );
    const data = JSON.stringify(dataFile);
    this.addfileHandler(file, data, customProperties);
    this.setState({ importBtndisable: false });
  };

  addfileHandler = async (event, data, customProperties) => {
    this.handleNext();
    this.setState({ importLoading: 0, activeStep: -1 });
    CostPlanStore.setImportLoading(0);
    if (event) {
      await CostPlanStore.setWbsSelected(event, data, customProperties);
    }
  };

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const { expanded } = this.state;
    const steps = getSteps();
    const { activeStep } = this.state;
    const isTrial = LoginStore.isTrialUser();
    return (
      <div className={classes.container}>
        <div
          className={classes.container}
          style={{
            overflowY: "scroll",
            height: `calc(100vh - ${isTrial ? 68 : 33}px)`,
          }}
        >
          <Paper elevation={2} square className={classes.paper}>
            <div className={classes.topBar}>
              <Typography className={classes.topBarText} component="span">
                {i18n.costplan.costPlanTitle}
              </Typography>
            </div>
            <div className={classes.topBar}>
              <div className={classes.topBarWrapper}>
                <Button
                  variant="outlined"
                  size="small"
                  className={classes.button}
                  style={{ color: "rgba(255, 255, 255, 0.6)" }}
                  aria-owns={anchorEl ? "simple-menu" : undefined}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                >
                  <Add
                    className={classNames(classes.leftIcon, classes.iconSmall)}
                  />
                  {i18n.modelMaps.menuLateral.newModel}
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}
                  className={classes.simpleMenu}
                >
                  <MenuItem
                    className={classes.simpleMenuItem}
                    selected={false}
                    onClick={this.handleClickOpen}
                  >
                    <Typography className={classes.simpleMenuText}>
                      {i18n.wbs.fromSpreadsheet}
                    </Typography>
                  </MenuItem>

                  <MuiThemeProvider theme={themeChangeCostPlan}>
                    <Dialog
                      open={CostPlanStore.getOpenBlankWbs()}
                      onClose={this.handleClickCloseBlankWbs}
                      aria-labelledby="draggable-dialog-title"
                      disableBackdropClick={true}
                      disableEscapeKeyDown={true}
                    >
                      <DialogTitle
                        id="draggable-dialog-title"
                        style={{ padding: "20px" }}
                        className={classes.modalWbsTitle}
                      >
                        <p
                          style={{
                            color: "rgb(0 0 0)",
                            fontSize: "18px",
                            margin: 0,
                          }}
                        >
                          {i18n.costplan.newCostPlanNameBlank}
                        </p>
                        <IconButton
                          onClick={this.handleClickClose}
                          className={classes.closeIcon}
                          style={{ position: "absolute" }}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </DialogTitle>

                      <DialogContent className={classes.modalWbsContent}>
                        <DialogContentText style={{ padding: 0 }}>
                          <form
                            className={classes.formContainer}
                            style={{ flexDirection: "column" }}
                            noValidate
                            autoComplete="off"
                          >
                            <TextField
                              id="standard-name"
                              label={i18n.costplan.costPlanName}
                              className={classes.textField}
                              value={this.state.nameWbs}
                              onChange={this.handleInputNameWbs}
                              error={this.state.nameWbsAlreadyExists == true}
                              helperText={
                                this.state.nameWbsAlreadyExists == true
                                  ? i18n.costplan.nameWbsAlreadyExists
                                  : ""
                              }
                              margin="normal"
                            />

                            <TextField
                              id="standard-name"
                              label={i18n.costplan.costPlanDescription}
                              className={classes.textField}
                              value={this.state.descriptionWbs}
                              onChange={this.handleInputDescriptionWbs}
                              margin="normal"
                            />
                          </form>
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions className={classes.modalWbsActions}>
                        <Button
                          onClick={this.handleClickClose}
                          className={classes.cancelButton}
                        >
                          {i18n.costplan.cancel}
                        </Button>
                        <Button
                          onClick={this.createBlankWbs}
                          disabled={this.state.fillInputNameWbs != true}
                          className={classes.createNewCostPlanButton}
                        >
                          {i18n.costplan.createNew}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </MuiThemeProvider>

                  <Dialog
                    open={CostPlanStore.getOpenGridDialog()}
                    onClose={this.handleClickClose}
                    aria-labelledby="draggable-dialog-title"
                    disableBackdropClick={true}
                    disableEscapeKeyDown={true}
                  >
                    <DialogTitle
                      id="draggable-dialog-title"
                      style={{ padding: "20px" }}
                    >
                      <p
                        style={{
                          color: "#f2f2f2",
                          fontSize: "18px",
                          margin: 0,
                        }}
                      >
                        {i18n.wbs.overlapData}
                      </p>
                      <IconButton
                        onClick={this.handleClickClose}
                        className={classes.closeIcon}
                        style={{ position: "absolute" }}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText style={{ padding: 0 }}>
                        <p
                          style={{
                            color: "#a6a6a6",
                            fontSize: "16px",
                            margin: 0,
                          }}
                        >
                          {i18n.wbs.signatureError}
                        </p>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button autoFocus className={classes.confirmButton}>
                        <input
                          style={{ display: "none" }}
                          id="button-file-upload"
                          type="file"
                          accept=".xls, .xlsx"
                          className={classes.input}
                          onChange={this.addfileHandler.bind(this)}
                        />
                        <label
                          htmlFor="button-file-upload"
                          style={{ cursor: "pointer", padding: "8px 16px" }}
                        >
                          <Typography style={{ color: "#ABC200" }}>
                            {i18n.yes}
                          </Typography>
                        </label>
                      </Button>
                      <Button onClick={this.handleClickClose} color="secondary">
                        {i18n.no}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Menu>
              </div>
            </div>

            {this.state.status === true ? (
              WBSStore.listWbs.map((wbs) => (
                <>
                  <CostPlanItem
                    wbs={wbs.data}
                    wbsId={wbs.id}
                    refresh={this.refreshComponent}
                  />
                </>
              ))
            ) : (
              <>
                <CircularProgress
                  className={classes.progress}
                  variant="indeterminate"
                />
              </>
            )}
          </Paper>
        </div>
        <Paper elevation={2} square className={classes.paper}>
          <div className={classes.topBar}>
            <Typography className={classes.topBarText} component="span">
              {i18n.costplan.costPlanTitle}
            </Typography>
          </div>
          <div className={classes.topBar}>
            <div className={classes.topBarWrapper}>
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                style={{ color: "rgba(255, 255, 255, 0.6)" }}
                aria-owns={anchorEl ? "simple-menu" : undefined}
                aria-haspopup="true"
                onClick={this.handleClick}
              >
                <Add
                  className={classNames(classes.leftIcon, classes.iconSmall)}
                />
                {i18n.modelMaps.menuLateral.newModel}
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
                className={classes.simpleMenu}
              >
                <MenuItem
                  className={classes.simpleMenuItem}
                  selected={false}
                  onClick={this.handleClickOpenBlankWbs}
                >
                  <Typography className={classes.simpleMenuText}>
                    {i18n.wbs.blank}
                  </Typography>
                </MenuItem>
                <MenuItem
                  className={classes.simpleMenuItem}
                  selected={false}
                  onClick={this.handleClickOpen}
                >
                  <Typography className={classes.simpleMenuText}>
                    {i18n.wbs.fromSpreadsheet}
                  </Typography>
                </MenuItem>
                <Dialog
                  className={classes.root}
                  open={CostPlanStore.getOpenGridDialog()}
                  onClose={this.handleClickClose}
                  aria-labelledby="draggable-dialog-title"
                  disableBackdropClick={true}
                  disableEscapeKeyDown={true}
                  classes={{
                    paperWidthSm: classes.teste,
                  }}
                >
                  <DialogTitle
                    className={classes.modalImportSheetTitle}
                    id="draggable-dialog-title"
                    style={{ order: 0 }}
                  >
                    {/* <p style={{fontSize: "1.25rem", margin: 0}}> */}
                    {i18n.wbs.importSettings}
                    {/* </p> */}
                  </DialogTitle>
                  {CostPlanStore.getImportLoading() === -1 ? (
                    <DialogContent
                      className={classes.modalImportSheetContent}
                      style={{
                        padding: "15px 20px 15px",
                        overflowY: "hidden",
                        maxHeight: "80px",
                        minHeight: "80px",
                      }}
                    >
                      <MuiThemeProvider theme={theme}>
                        <Stepper
                          style={{
                            backgroundColor: "#EEEEEE",
                            padding: "5px",
                          }}
                          classes={{
                            alternativeLabel: classes.stepperAlternativeLabel,
                          }}
                          activeStep={activeStep}
                          alternativeLabel
                        >
                          {steps.map((label, index) => (
                            <Step
                              className={classes.bolinha}
                              key={label}
                              onClick={() => this.handleBackToStep(index)}
                              disabled={false}
                            >
                              <StepLabel classes={{ label: classes.stepLabel }}>
                                {label}
                              </StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </MuiThemeProvider>
                    </DialogContent>
                  ) : (
                    ""
                  )}
                  <DialogContent
                    className={classes.modalImportSheetContent}
                    style={{
                      padding: "0px 20px 0px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent:
                        CostPlanStore.getImportLoading() != -1
                          ? "center"
                          : "flex-start",
                    }}
                  >
                    <>
                      {this.state.activeStep === steps.length ? (
                        <></>
                      ) : (
                        <Typography
                          style={{
                            margin: "0px 15px 0px",
                            fontSize: "14px",
                          }}
                          className={classes.instructions}
                        >
                          {getStepContent(activeStep)}
                        </Typography>
                      )}
                      {CostPlanStore.getImportLoading() != -1 &&
                      CostPlanStore.importCostPlanFileStatus == "pending" ? (
                        <LoadingLayer classes={classes} />
                      ) : CostPlanStore.getImportLoading() != -1 &&
                        CostPlanStore.importCostPlanFileStatus ==
                          "processing" ? (
                        <ProcessingLayer
                          progress={Number(
                            CostPlanStore.importCostPlanFileProgess
                          )}
                          time={0.5}
                          classes={classes}
                        />
                      ) : CostPlanStore.getImportLoading() != -1 &&
                        CostPlanStore.importCostPlanFileStatus ==
                          "processed" ? (
                        <FinishedLayer
                          classes={classes}
                          onClose={this.handleClickClose}
                        />
                      ) : CostPlanStore.getImportLoading() != -1 &&
                        CostPlanStore.importCostPlanFileStatus == "error" ? (
                        <ErrorLayer
                          onReset={this.handleClickReset}
                          onClose={this.handleClickClose}
                          message={CostPlanStore.importCostPlanFileErrorMessage}
                          classes={classes}
                        />
                      ) : (
                        ""
                      )}
                    </>
                  </DialogContent>
                  <DialogActions className={classes.modalImportActions}>
                    {activeStep != -1 ? (
                      <Button onClick={this.handleClickClose} color="secondary">
                        Cancelar
                      </Button>
                    ) : (
                      ""
                    )}
                    {activeStep == 0 ? (
                      CostPlanStore.fileUploadName !== null ? (
                        <Button color="primary" onClick={this.handleNext}>
                          {i18n.wbs.continue}
                        </Button>
                      ) : (
                        <Button color="primary" disabled={true}>
                          {i18n.wbs.continue}
                        </Button>
                      )
                    ) : null}
                    {activeStep == 1 ? (
                      CostPlanStore.fillStructCodeColumn == true &&
                      CostPlanStore.fillDescriptionColumn ? (
                        <Button color="primary" onClick={this.handleNext}>
                          {i18n.wbs.continue}
                        </Button>
                      ) : (
                        <Button color="primary" disabled={true}>
                          {i18n.wbs.continue}
                        </Button>
                      )
                    ) : null}
                    {activeStep == 2 ? (
                      <Button
                        color="primary"
                        disabled={this.state.importBtndisable}
                        onClick={this.importSheet}
                      >
                        {i18n.wbs.import}
                      </Button>
                    ) : null}
                  </DialogActions>
                </Dialog>
              </Menu>
            </div>
          </div>
          {CostPlanStore.wbsSelected &&
          CostPlanStore.wbsSelected.data.status !== "error" ? (
            <div className={classes.eapWrapper}>
              {CostPlanStore.wbsSelected.data.progress !== 100 ? (
                <React.Fragment>
                  <div>
                    <Typography className={classes.eapName}>
                      {CostPlanStore.wbsSelected &&
                        CostPlanStore.wbsSelected.data.name}
                    </Typography>
                    <Typography className={classes.eapProgress}>
                      {i18n.wbs.processing}{" "}
                      {CostPlanStore.wbsSelected.data.progress} %
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      paddingRight: "2px",
                    }}
                  >
                    <CircularProgress
                      className={classes.progress}
                      variant="indeterminate"
                    />
                  </div>
                </React.Fragment>
              ) : (
                <div>
                  <Typography className={classes.eapName}>
                    {CostPlanStore.wbsSelected.data.name}
                  </Typography>
                  <div className={classes.eapProgress}>
                    {formatMonetary(WBSStore.WBS.data.totalCost)}
                  </div>
                </div>
              )}
            </div>
          ) : CostPlanStore.wbsSelected === false ? (
            <div className={classes.eapWrapper}>
              <div>
                <Typography className={classes.eapProgress}>
                  {i18n.wbs.preparing}
                </Typography>
              </div>
              <div
                id="statusicon"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  paddingRight: "2px",
                }}
              >
                <CircularProgress
                  className={classes.progress}
                  variant="indeterminate"
                />
              </div>
            </div>
          ) : (
            <div className={classes.eapWrapper}>
              <div>
                <Typography className={classes.eapName}>
                  {WBSStore.WBS.data.name}
                </Typography>
                <Typography className={classes.eapProgress}>
                  {formatMonetary(WBSStore.totalCost)}
                </Typography>
              </div>
            </div>
          )}
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(withSnackbar(CostPlanGrid));



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/pages/CostPlanGrid.tsx